import { Link } from 'react-router-dom'
import { money } from '../sales/salesShared'

export const BUCKETS = [['current', 'Not yet due'], ['d30', '1–30 days'], ['d60', '31–60'], ['d90', '61–90'], ['d90p', 'Over 90']]
const wide = (k) => (k === 'current' || k === 'd90p' ? '' : ' hide-sm')
const cell = (v) => (Math.abs(Number(v) || 0) < 0.005 ? '' : money(v))
// On a phone the four late buckets are one "Overdue" column.
const overdue = (r) => ['d30', 'd60', 'd90', 'd90p'].reduce((s, k) => s + (Number(r[k]) || 0), 0)

// Open balances by how long past due they are: one row per vendor or
// customer (from the aging endpoints), with totals over the rows shown.
export default function AgingTable({ party, rows, idKey, nameKey, link, emptyText }) {
  const total = (k) => rows.reduce((s, r) => s + (Number(r[k]) || 0), 0)
  return (
    <table className="fs-table sl-aging">
      <thead>
        <tr>
          <th>{party}</th>
          <th className="num">Balance</th>
          {BUCKETS.map(([k, label]) => <th key={k} className={`num${wide(k)}`}>{label}</th>)}
          <th className="num sl-sm-only">Overdue</th>
          <th className="num hide-sm">Oldest</th>
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 && <tr className="fs-note"><td colSpan="9">{emptyText}</td></tr>}
        {rows.map((r) => (
          <tr key={r[idKey] || r[nameKey]}>
            <td>{r[idKey] && link ? <Link className="fs-link" to={link(r[idKey])}>{r[nameKey] || `${party} #${r[idKey]}`}</Link> : (r[nameKey] || `Not linked to a ${party.toLowerCase()}`)}</td>
            <td className="num">{money(r.balance)}</td>
            {BUCKETS.map(([k]) => <td key={k} className={`num${wide(k)}${k === 'd90p' && r.d90p ? ' sl-late' : ''}`}>{cell(r[k])}</td>)}
            <td className={`num sl-sm-only${overdue(r) ? ' sl-late' : ''}`}>{cell(overdue(r))}</td>
            <td className="num hide-sm">{r.days_outstanding ? `${r.days_outstanding} days` : ''}</td>
          </tr>
        ))}
        {rows.length > 0 && (
          <tr className="fs-grand">
            <td>Total</td>
            <td className="num">{money(total('balance'))}</td>
            {BUCKETS.map(([k]) => <td key={k} className={`num${wide(k)}`}>{cell(total(k))}</td>)}
            <td className="num sl-sm-only">{cell(rows.reduce((s, r) => s + overdue(r), 0))}</td>
            <td className="hide-sm" />
          </tr>
        )}
      </tbody>
    </table>
  )
}
